import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import { TextButton, TextButtonPriority } from '@wix/wix-ui-tpa';
import ShowMoreText from 'react-show-more-text';
import settingsParams from '../../../settingsParams';
import s from './ProductDescription.scss';
import { useControllerProps } from '../../ControllerContext';
import { Property } from 'csstype/index';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { SPECS } from '../../../../../consts';

export const ProductDescriptionDataHook = {
  description: 'ProductDescription.description',
};

const ProductDescription = () => {
  const settings = useSettings();
  const { product } = useControllerProps().giftCardStore;
  const { experiments } = useExperiments();

  const description = product?.description;
  const enableLongDescription = experiments.enabled(
    SPECS.EnableLongDescription,
  );

  const moreLessButton = (isCollapsed: boolean) => {
    return (
      <>
        <div></div>
        <TextButton
          className={s.moreLessButton}
          data-hook={
            isCollapsed
              ? 'rise-gift-card-product-description-read-more-button'
              : 'rise-gift-card-product-description-less-button'
          }
          priority={TextButtonPriority.link}
        >
          {isCollapsed
            ? settings.get(settingsParams.descriptionReadMoreButton)
            : settings.get(settingsParams.descriptionReadLessButton)}
        </TextButton>
      </>
    );
  };

  return enableLongDescription ? (
    <div
      className={s.description}
      style={{
        textAlign: settings.get(
          settingsParams.productTitleAlignment,
        ) as Property.TextAlign,
      }}
    >
      <p data-hook={ProductDescriptionDataHook.description}>
        <ShowMoreText
          lines={settings.get(settingsParams.descriptionLimitRows)}
          more={moreLessButton(true)}
          less={moreLessButton(false)}
          expanded={false}
          keepNewLines={true}
        >
          {description}
        </ShowMoreText>

        <div style={{ display: 'none' }}>{description}</div>
      </p>
    </div>
  ) : (
    <div
      className={s.description}
      style={{
        textAlign: settings.get(
          settingsParams.productTitleAlignment,
        ) as Property.TextAlign,
      }}
    >
      <p>
        <span
          data-hook={ProductDescriptionDataHook.description}
          className={s.descriptionText}
        >
          {description}
        </span>
        <div style={{ display: 'none' }}>{description}</div>
      </p>
    </div>
  );
};

export default ProductDescription;
